import {
  AiAssetUrlPrefix,
  type AiApprovalResponse,
  type AiChatRequestInput,
  type AiLocale,
} from '@restaurant/api-contracts';
import { isToolUIPart, type UIMessage } from 'ai';

export function buildChatRequest(params: {
  threadId: string;
  locale: AiLocale;
  messages: UIMessage[];
}): AiChatRequestInput {
  const last = params.messages.at(-1);
  if (!last) throw new Error('No message to send.');

  if (last.role === 'assistant') {
    const responses: AiApprovalResponse[] = last.parts.flatMap((part) =>
      isToolUIPart(part) && part.state === 'approval-responded'
        ? [
            {
              approvalId: part.approval.id,
              approved: part.approval.approved,
              ...(part.approval.reason ? { reason: part.approval.reason } : {}),
            },
          ]
        : [],
    );
    return {
      threadId: params.threadId,
      locale: params.locale,
      message: { type: 'approvals', responses },
    };
  }

  const text = last.parts.flatMap((part) => (part.type === 'text' ? [part.text] : [])).join('\n');
  const assetIds = last.parts.flatMap((part) =>
    part.type === 'file' && part.url.startsWith(AiAssetUrlPrefix)
      ? [part.url.slice(AiAssetUrlPrefix.length)]
      : [],
  );
  return {
    threadId: params.threadId,
    locale: params.locale,
    message: { type: 'user', text, assetIds },
  };
}
